export default defineNuxtRouteMiddleware(async (to, from) => {
    function getAllCookiesByteSize() {
        const cookies = document.cookie.split("; ");
        let totalSize = 0;
        const cookieSizes: { [key: string]: number } = {};

        cookies.forEach((cookie) => {
            const [name, value] = cookie.split("=");
            const blob = new Blob([value || ""]);
            const size = blob.size;

            cookieSizes[name] = size;
            totalSize += size;
        });

        return { totalSize, cookieSizes };
    }

    function removeAllCookies() {
        const cookies = document.cookie.split("; ");

        cookies.forEach((cookie) => {
            const [name] = cookie.split("=");
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        });

        console.log("All cookies have been removed.");
    }

    if (process.client) {
        try {
            const { totalSize, cookieSizes } = getAllCookiesByteSize();

            if (totalSize >= 5000) {
                console.log("Cookie size too big", totalSize, cookieSizes);
                removeAllCookies();
            } else {
                console.log("Cookie size ok", totalSize, cookieSizes);
            }
        } catch (error) {}
    }
});
